import { QuestionCircleOutlined } from '@ant-design/icons'
import { Button, Collapse, Drawer, Typography } from 'antd'
import { FC, useState } from 'react'

const { Paragraph, Text } = Typography

const HelpDrawer: FC = () => {
    const [open, setOpen] = useState(false)

    return (
        <>
            <Button icon={<QuestionCircleOutlined />} onClick={() => setOpen(true)}>
                Справка
            </Button>
            <Drawer title='Задачи корректора' open={open} onClose={() => setOpen(false)} width={480}>
                <Collapse
                    defaultActiveKey={['1']}
                    items={[
                        {
                            key: '1',
                            label: <b>Обзор</b>,
                            children: (
                                <>
                                    <Paragraph>
                                        Здесь отображаются задачи типа{' '}
                                        <Text strong>«Подтверждение корректором»</Text> — проверка
                                        сборки форм после подготовки дизайнером.
                                    </Paragraph>
                                    <ul>
                                        <li>
                                            Вкладка <Text strong>Новые</Text> — ожидают решения.
                                        </li>
                                        <li>
                                            Вкладка <Text strong>Завершенные</Text> — согласованные
                                            или отправленные в доработку.
                                        </li>
                                    </ul>
                                </>
                            ),
                        },
                        {
                            key: '2',
                            label: <b>Действия</b>,
                            children: (
                                <ul>
                                    <li>
                                        <Text strong>Согласовать</Text> — завершает задачу и создаёт
                                        дизайнеру задачу «Заказ форм».
                                    </li>
                                    <li>
                                        <Text strong>В доработку</Text> — нужен комментарий (можно
                                        приложить скрины). Создаётся задача «Внесение правок»
                                        дизайнеру; после правок подтверждение придёт снова.
                                    </li>
                                </ul>
                            ),
                        },
                    ]}
                />
            </Drawer>
        </>
    )
}

export default HelpDrawer
